import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { ChatRole } from '@app/enums';
import { ChatMessage } from '@app/interfaces';

@Injectable()
export class ActiveConversationService {
    private readonly responseLoading$: Subject<boolean> = new Subject<boolean>();
    private readonly newMessage$: BehaviorSubject<ChatMessage | undefined> = new BehaviorSubject<
        ChatMessage | undefined
    >(undefined);

    constructor() {}

    showResponseLoader(): void {
        this.responseLoading$.next(true);
    }

    hideResponseLoader(): void {
        this.responseLoading$.next(false);
    }

    responseLoadingChange(): Observable<boolean> {
        return this.responseLoading$.asObservable();
    }

    newMessageChange(): Observable<ChatMessage | undefined> {
        return this.newMessage$.asObservable();
    }

    addUserMessage(message: string): ChatMessage {
        const userMessage: ChatMessage = this.createMessage(message, ChatRole.User);

        this.newMessage$.next(userMessage);

        return userMessage;
    }

    addAssistantMessage(message: string, requestId?: string): ChatMessage {
        const assistantMessage: ChatMessage = this.createMessage(message, ChatRole.Assistant, requestId);

        this.newMessage$.next(assistantMessage);

        return assistantMessage;
    }

    private createMessage(content: string, role: ChatRole, requestId?: string): ChatMessage {
        return {
            content,
            role,
            requestId
        };
    }
}
